module.exports = __webpack_public_path__ + "static/irishTap-1065fde2e776f62508197328e0a35232.mp3";